package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ClassConversationListResponse(
    val id: String? = null,
    @SerialName("conversation_code") val conversationCode: String? = null,
    val title: String? = null,
    val status: String? = null,
    @SerialName("reply_count") val replyCount: Int? = null,
    @SerialName("author_id") val authorId: String? = null,
    @SerialName("author_name") val authorName: String? = null,
    @SerialName("posted_on") val postedOn: String? = null,
    @SerialName("class_name") val className: String? = null,
    @SerialName("section_name") val sectionName: String? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("attachment_url") val attachmentUrl: String? = null,
    @SerialName("attachment_filename") val attachmentFilename: String? = null,
    @SerialName("attachment_size_bytes") val attachmentSizeBytes: Int? = null
)

@Serializable
data class ClassConversationResponse(
    val id: String? = null,
    @SerialName("conversation_code") val conversationCode: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("class_section_id") val classSectionId: String? = null,
    @SerialName("class_name") val className: String? = null,
    @SerialName("section_name") val sectionName: String? = null,
    val title: String? = null,
    val description: String? = null,
    @SerialName("attachment_url") val attachmentUrl: String? = null,
    @SerialName("attachment_filename") val attachmentFilename: String? = null,
    @SerialName("attachment_size_bytes") val attachmentSizeBytes: Int? = null,
    val status: String? = null,
    @SerialName("reply_count") val replyCount: Int? = null,
    @SerialName("author_id") val authorId: String? = null,
    @SerialName("author_role") val authorRole: String? = null,
    @SerialName("author_name") val authorName: String? = null,
    @SerialName("posted_on") val postedOn: String? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null
)

@Serializable
data class ClassConversationReplyResponse(
    val id: String? = null,
    @SerialName("conversation_id") val conversationId: String? = null,
    @SerialName("reply_text") val replyText: String? = null,
    @SerialName("attachment_url") val attachmentUrl: String? = null,
    @SerialName("attachment_filename") val attachmentFilename: String? = null,
    @SerialName("author_id") val authorId: String? = null,
    @SerialName("author_role") val authorRole: String? = null,
    @SerialName("author_name") val authorName: String? = null,
    @SerialName("created_at") val createdAt: String? = null
)
